import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useAuth } from '@/shared/contexts/AuthContext';
import { tenantHomePath } from '@/shared/hooks/useTenantHomePath';

export function EmpresaIdGuard() {
  const { empresaId: param } = useParams<{ empresaId?: string }>();
  const { role, empresaId: jwtEmpresaId } = useAuth();

  if (role === 'tenant' && param && jwtEmpresaId && param !== jwtEmpresaId) {
    return <Navigate to={tenantHomePath(jwtEmpresaId)} replace />;
  }

  return <Outlet />;
}
